module.exports = __webpack_public_path__ + "static/media/orange.21d8a916.png";